<template>
  <div>
    <p style="margin-bottom: 0in; line-height: 100%">
      <font size="4" style="font-size: 14pt"><b>PLATA
          SI MODALITATILE DE PLATA A PACHETELOR DE CALATORIE</b></font>
    </p>
    <ol type="a">
      <li>
        <p align="justify" style="margin-bottom: 0.11in; line-height: 108%">
          <b>30%</b> din valoarea totala a pachetului se achita <b>in maxim 3
            zile</b> de la efectuarea rezervarii
        </p>
      </li>
      <li>
        <p align="justify" style="margin-bottom: 0.11in; line-height: 108%">
          Diferenta pana la <b>50%</b> din valoarea totala a pachetului se
          achita pana la <b>maxim 61 zile</b> inainte de data plecarii</p>
      </li>
      <li>
        <p align="justify" style="margin-bottom: 0.11in; line-height: 108%">
          Diferenta pana la <b>100%</b> din valoarea totala a pachetului se
          achita pana la <b>maxim 31 zile</b> inainte de data plecarii</p>
      </li>
    </ol>
    <p style="margin-bottom: 0in; line-height: 100%">Va punem la
      dispozitie urmatoarele metode de plata:</p>
    <ul>
      <li>
        <p style="margin-top: 0.19in; margin-bottom: 0in; line-height: 100%">
          Pentru <b>
            <font color="#3498db">plata card online</font>
          </b>,
          va rugam sa solicitati un link de plata.<b> Acolo puteti achita
            transa curenta sau puteti opta pentru plata integrala</b></p>
      </li>
      <li>
        <p style="margin-bottom: 0in; line-height: 100%">Pentru <b>
            <font color="#3498db">plata
              prin transfer bancar</font>
          </b>, folositi urmatoarele detalii
          bancare:</p>
      </li>
      <ul>
        <li>
          <p style="margin-bottom: 0in; line-height: 100%"><b>Banca
              RAIFFEISEN BANK</b></p>
          <ul>
            <li>
              <p style="margin-bottom: 0in; line-height: 100%">IBAN: RO53
                RZBR 0000 0600 0372 7537 (RON)</p>
            </li>
            <li>
              <p style="margin-bottom: 0in; line-height: 100%">IBAN: RO91
                RZBR 0000 0600 0375 2752 (EUR)</p>
            </li>
          </ul>
        </li>
        <li>
          <p style="margin-bottom: 0in; line-height: 100%"><b>Banca BRD</b></p>
          <ul>
            <li>
              <p style="margin-bottom: 0in; line-height: 100%">IBAN: RO02
                BRDE 410S V631 3901 4100 (RON)</p>
            </li>
            <li>
              <p style="margin-bottom: 0in; line-height: 100%">IBAN: RO37
                BRDE 410S V631 3928 4100 (EUR)</p>
            </li>
          </ul>
        </li>
        <li>
          <p style="margin-bottom: 0in; line-height: 100%"><b>Banca
              TRANSILVANIA</b></p>
          <ul>
            <li>
              <p style="margin-bottom: 0in; line-height: 100%">IBAN: RO06
                BTRL RONC RT06 1753 2201 (RON)</p>
            </li>
            <li>
              <p style="margin-bottom: 0.19in; line-height: 100%">IBAN: RO53
                BTRL EURC RT06 1753 2201 (EUR)</p>
            </li>
          </ul>
        </li>
      </ul>
    </ul>
    <p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
      Va rugam sa mentionati la detaliile plati codul de rezervare.</p>
    <p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
      <font face="Calibri, serif">
        <font color="#ff0000"><b>Atentie! In caz
            de neplata la termen, rezervarea dvs se va anula conform
            contractului.</b></font>
      </font>
    </p>
    <p style="margin-top: 0.19in; margin-bottom: 0.19in; line-height: 100%">
      <br />
      <br />

    </p>
    <p style="margin-bottom: 0in; line-height: 100%">
      <font size="4" style="font-size: 14pt"><b>CONDITII
          DE ANULARE</b></font>
    </p>
    <p align="justify" style="text-indent: 0.5in; margin-bottom: 0.11in; line-height: 108%">
      Calatorul poate inceta contractul in orice moment, inainte de
      inceperea executarii pachetului. In cazul in care Calatorul renunta
      din vina sa la pachetul de servicii de calatorie care face obiectul
      prezentului contract, el datoreaza Agentiei penalizari dupa cum
      urmeaza:</p>
    <p align="justify" style="margin-bottom: 0.11in; line-height: 108%">(a)
      10% din pretul pachetului de servicii, daca renuntarea se face cu mai
      mult de 61 de zile calendaristice inainte de inceperea executarii
      pachetului (data plecarii);</p>
    <p align="justify" style="margin-bottom: 0.11in; line-height: 108%">(b)
      50% din pretul pachetului de servicii, daca renuntarea se face in
      intervalul de 60-31 zile inainte de inceperea executarii pachetului
      (data plecarii);</p>
    <p align="justify" style="margin-bottom: 0.11in; line-height: 108%">(c)
      100% din pretul pachetului de servicii daca renuntarea se face cu mai
      putin de 31 de zile inainte de inceperea executarii pachetului (data
      plecarii) sau nu se prezinta la program.</p>
    <p align="justify" style="margin-bottom: 0.11in; line-height: 108%">(d)
      100% din pretul pachetului de servicii, in cazul in care Calatorul a
      achizitionat pachetul de servicii de calatorie din cadrul programului
      special de tip Early Booking, indiferent de data la care Calatorul
      solicita renuntarea.</p>
    <p align="justify" style="margin-bottom: 0.11in; line-height: 108%"><br />
      <br />

    </p>
    <p style="margin-bottom: 0in; line-height: 100%">
      <font size="4" style="font-size: 14pt"><b>TRANSFERURI
          DIN PROVINCIE</b></font>
    </p>
    <p align="justify" style="text-indent: 0.5in; margin-bottom: 0.11in; line-height: 108%">
      Agentia de turism organizatoare Interra Travel ofera, la solicitarea
      de rezervare in scris din partea calatorului, transferuri contra cost
      la aeroportul Otopeni (pentru pachetele de calatorie cu transport
      avion) sau la punctele de imbarcare (pentru pachetele cu transport
      autocar) de pe rutele si orasele indicate in programul detaliat al
      pachetelor de calatorie. <font color="#000000"><span lang="ro-RO">Transferul
          se rezerva odata cu pachetul turistic DOAR la cererea expresa a
          turistului! Ulterior acesta nu mai poate fi confirmat decat in limita
          locurilor disponibile si cu minim 21 de zile inainte de plecare.
          Tarifele mentionate in oferta sunt pe persoana, valabile pentru
          ambele sensuri (dus-intors).</span></font>
    </p>
    <ul>
      <li>
        <p align="justify" style="margin-bottom: 0in; line-height: 100%">
          <span lang="ro-RO">TRANSFERUL DIN PROVINCIE la punctele de imbarcare
            sau la aeroport este oferit de INTERRA cu ajutorul partenerilor sau
            cu masini proprii. Daca pasagerul renunta la transferul de DUS,
            transferul de retur se anuleaza automat. Acesta va putea fi asigurat
            doar la cerere si doar daca vor mai fi locuri disponibile la acel
            moment in mijlocul de transport.</span>
        </p>
      </li>
      <li>
        <p align="justify" style="margin-bottom: 0in; line-height: 100%">
          <span lang="ro-RO"><b>Prezentarea la transfer se face cu minim 15
              minute inainte de ora de plecare comunicata</b></span><span lang="ro-RO">.</span>
        </p>
      </li>
      <li>
        <p align="justify" style="margin-bottom: 0in; line-height: 100%">
          <span lang="ro-RO">Pasagerii care beneficiaza de TRANSFER au
            obligatia de a comunica agentiei revanzatoare sau Tour Operator-ului
            un numar de telefon mobil la care sa poata fi contactati de soferi
            in cazul unor modificari neprevazute care pot aparea in ziua
            transferului. Tour Operatorul nu-si asuma raspunderea pentru
            eventuale neprezentari la transfer ale pasagerilor, care au drept
            consecinta pierderea avionului. In acest caz, costurile suplimentare
            generate de un nou bilet de avion sau modificarea celui existent vor
            fi suportate de pasager.</span>
        </p>
      </li>
      <li>
        <p align="justify" style="margin-bottom: 0in; line-height: 100%">
          <span lang="ro-RO">Transferurile sunt asigurate de Tour Operator cu
            mijloace auto ale companiilor de transport partenere pe rute
            regulate de transport pasageri </span><span lang="ro-RO"><b>SAU</b></span><span lang="ro-RO">
            cu mijloace auto din flota proprie (autoturisme pentru 1-4 pasageri,
            microbuze de 6, 8 respectiv 15 locuri, midiautocar de 26 de locuri).
            Pasagerii vor fi anuntati cu 2-3 zile inainte de plecare care sunt
            detaliile finale legate de transfer (loc de preluare, ora, mijloc de
            transport). </span>
        </p>
      </li>
      <li>
        <p align="justify" style="margin-bottom: 0in; line-height: 100%">
          <span lang="ro-RO">La returul din excursie turistii care beneficiaza
            de transfer vor primi cu 1-2 zile inainte de retur, pe numarul de
            telefon transmis la rezervare, voucher-ul de transfer (in cazul in
            care acesta se realizeaza cu ajutorul companiilor de transport
            partenere; in caz contrar, pasagerii vor fi asteptati la aeroport de
            catre soferii nostri, cu placuta cu Interra).</span>
        </p>
      </li>
      <li>
        <p align="justify" style="margin-bottom: 0in; line-height: 100%">
          <span lang="ro-RO">Daca Tour Operatorul are de asigurat in aceeasi
            zi transferuri pe aceeasi ruta si din aceleasi orase pentru 2 sau
            mai multe excursii cu plecare sau sosire in aceeasi zi, se va
            organiza un singur </span><span lang="ro-RO"><b>transfer cumulat</b></span><span lang="ro-RO">
            pentru toti pasagerii din excursiile respective. In acest caz, pot
            aparea </span><span lang="ro-RO"><b>timpi de asteptare de 1 pana la
              3 ore</b></span><span lang="ro-RO">. In acest caz, pasagerii vor fi
            anuntati si trebuie sa confirme daca doresc sa beneficieze de
            transferul cumulat sau nu. </span>
        </p>
      </li>
      <li>
        <p align="justify" style="margin-bottom: 0in; line-height: 100%">
          <span lang="ro-RO">Tour Operatorul nu isi asuma raspunderea in
            situatia putin probabila a aparitiei unor evenimente neprevazute
            (blocarea traficului rutier, inzapezirea drumurilor, inundatii,
            accidente rutiere, etc) care pot duce la intarzierea transferului si
            pierderea zborului. </span>
        </p>
      </li>
      <li>
        <p align="justify" style="margin-bottom: 0in; line-height: 100%">
          <span lang="ro-RO">Turistii au obligatia de a mentine curatenia in
            mijlocul de transport pe tot parcursul transferului. In mijlocul de
            transport nu este permis fumatul, consumul de bauturi alcoolice si
            produse alimentare. </span>
        </p>
      </li>
    </ul>
    <p align="justify" style="margin-bottom: 0.11in; line-height: 108%"><span lang="ro-RO">Transferurile
        din provincie se asigura in conformitate cu reglementarile legale in
        vigoare cu privire la transportul de persoane si cu respectarea
        timpilor de condus ai soferilor. Din acest considerent, soferii vor
        face pauzele de odihna impuse de lege in vederea asigurarii unui
        transport in conditii de siguranta.</span></p>
    <p align="justify" style="margin-bottom: 0.11in; line-height: 108%"><br />
      <br />

    </p>
    <p style="margin-bottom: 0in; line-height: 100%">
      <font size="4" style="font-size: 14pt"><b>CAZARE
          SI PROGRAMUL EXCURSIEI</b></font>
    </p>
    <ul>
      <li>
        <p align="justify" style="margin-bottom: 0.11in; line-height: 108%">
          Clasificarea hotelurilor din programul pachetelor de calatorie este
          in conformitate cu standardele existente in tara respectiva si poate
          sa nu coincida cu normele de clasificare din Romania.
        </p>
      </li>
      <li>
        <p align="justify" style="margin-bottom: 0.11in; line-height: 108%">
          Hotelurile nominalizate in program pot suferi modificari pana la
          data plecarii, in functie de conditiile specific care pot aparea
          intre momentul publicarii programului si data plecarii. Daca aceste
          schimbari sunt impuse de furnizorul local, intotdeauna se vor oferi
          hoteluri similare ca locatie/confort, fara a implica plata unor
          costuri suplimentare pentru turist.
        </p>
      </li>
      <li>

        <p align="justify" style="margin-bottom: 0.11in; line-height: 108%">
          Majoritatea hotelurilor nu detin camere triple. In unele hoteluri se
          pot confirma la cerere camere duble cu pat suplimentar, in functie
          de disponibilitate. Patul suplimentar pote fi un pat pliant, un
          fotoliu pat, o canapea extensibila, etc.
        </p>
      </li>
      <li>
        <p align="justify" style="margin-bottom: 0.11in; line-height: 108%">
          Distributia camerelor la hoteluri se face de catre receptiile
          acestora; problemele legate de amplasarea sau aspectul camerei se
          rezolva de catre calator (turist) direct la receptie, asistat de
          reprezentantul agentiei. Pentru anumite facilitati din hotel sau din
          camera, hotelierul poate solicita taxe suplimentare
          (minibar/frigider, seif, etc.); in momentul sosirii la hotel
          solicitati receptionerului sa va informeze cu exactitate asupra lor.
        </p>
      </li>
      <li>
        <p align="justify" style="margin-bottom: 0.11in; line-height: 108%">
          Situatia de <i><b>partaj in camera dubla</b></i> este atunci cand o
          persoana doreste sa participe la o excursie singura, dar nu in
          camera single, ci cu alta persoana, necunoscuta, de acelasi sex,
          intr-o camera twin pentru doua persoane. In aceasta situatie
          persoana in cauza solicita Agentiei de Turism Organizatoare o
          rezervare partaj in camera dubla, sub rezerva ca Agentia de Turism
          Organizatoare va gasi, in timp util, a doua persoana dispusa sa
          participe la excursie partaj in camera dubla. Daca nu se va gasi a
          doua persoana, prima persoana se poate retrage, sau va achita
          suplimentul de camera single pentru a putea participa la excursie.
        </p>
      </li>
      <li>
        <p align="justify" style="margin-bottom: 0.11in; line-height: 108%">
          Insotitorul de grup poate efectua modificari programului (schimbari
          de ore, modificarea ordinii desfasurarii acestuia), fara a afecta
          insa structura serviciilor, pe care este obligat sa le efectueze in
          integralitatea lor.</p>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'TermsAndConditions'
}
</script>

<style lang="scss" scoped></style>
